import { createAction } from "@ngrx/store";

export const toggleLanguage = createAction("[i18n] Toggle language");
